<template>
    <v-dialog
        v-model="$store.state.tracking.CKDroppedList"
        width="1220px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="primary" dense>
                <v-btn icon dark @click="loadOrderCK(ShiftDetailId)">
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
                <v-btn dark icon @click="filterData"
                    ><v-icon>mdi-filter</v-icon></v-btn
                >
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >CK Products Dropped</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.tracking.CKDroppedList = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid :ripple="false" v-if="!spinner">
                <v-simple-table fixed-header height="800px" dense>
                    <tbody
                        v-for="(ord, index) in filteredItems"
                        v-bind:key="index"
                    >
                        <template>
                            <tr v-if="ord.show">
                                <th colspan="10">{{ ord.DriverName }}</th>
                            </tr>
                            <tr v-if="ord.show">
                                <th colspan="2">Order</th>
                                <th>Terminal</th>
                                <th colspan="2">Station</th>
                                <th colspan="3">Products</th>
                            </tr>
                            <tr style="border-bottom: 1px solid #000;">
                                <td
                                    :style="'background:' + ord.color + ';'"
                                    colspan="2"
                                >
                                    {{ ord.OrderID }}
                                </td>
                                <td :style="'background:' + ord.color + ';'">
                                    {{ ord.TerminalName }}
                                </td>
                                <td :style="'background:' + ord.color + ';'">
                                    {{ ord.StationName }}
                                </td>
                                <td
                                    :style="'background:' + ord.color + ';'"
                                ></td>
                                <td :style="'background:' + ord.color + ';'">
                                    Product
                                </td>
                                <td :style="'background:' + ord.color + ';'">
                                    Prod. Qty
                                </td>
                                <td :style="'background:' + ord.color + ';'">
                                    Disp. Qty
                                </td>
                            </tr>
                            <template v-for="(ordt, idx) in ord.order_details">
                                <tr v-bind:key="ordt.OrderProdID">
                                    <td
                                        v-if="idx == 0"
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ord.LoadNum }}
                                    </td>
                                    <td
                                        v-if="idx == 0"
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ord.LoadNum }}
                                    </td>
                                    <td
                                        v-if="idx == 0"
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ord.StStart }}
                                    </td>
                                    <td
                                        v-if="idx == 0"
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ord.StEnd }}
                                    </td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                        colspan="4"
                                        v-else
                                    ></td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                        v-if="ordt.hasCKDropped"
                                    >
                                        <v-icon color="success" small
                                            >mdi-check-circle</v-icon
                                        >
                                    </td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                        v-else
                                    ></td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ordt.Product }}
                                    </td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ordt.ProductQuantity }}
                                    </td>
                                    <td
                                        :style="'background:' + ord.color + ';'"
                                    >
                                        {{ ordt.DispatchedQuantity }}
                                    </td>
                                </tr>
                            </template>
                            <tr v-bind:key="index">
                                <td
                                    colspan="5"
                                    :style="'background:' + ord.color + ';'"
                                ></td>
                                <td
                                    colspan="3"
                                    :style="
                                        'background:' +
                                            ord.color +
                                            ';color:red;'
                                    "
                                >
                                    ({{ ord.Diff }} lts. Diff) {{ ord.Justify }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </v-simple-table>
            </v-container>
            <v-container grid-list-xs v-else>
                <div class="spinner mb-5">
                    <div class="sk-chase">
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                    </div>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['ShiftId'],
    data: () => {
        return {
            data: [],
            ShiftDetailId: 0,
            widthField: 3,
            unique: [],
            unqOrd: [],
            search: null,
            banner: null,
            spinner: false
        };
    },
    async mounted() {
        this.loadOrderCK(this.ShiftId);
    },
    computed: {
        filteredItems() {
            return this.unqOrd.filter(i => {
                return !this.banner || i.dropped == this.banner;
            });
        }
    },
    methods: {
        filterData: function() {
            if (this.banner == 0 || this.banner == null) {
                this.banner = 1;
            } else {
                this.banner = 0;
            }

            console.log(this.banner);
        },
        openData: function(itm) {
            //this.data = [];
            this.order = itm;
            this.$store.state.tracking.editProduct = false;
            this.$store.state.orderTracking = itm;
            this.$store.state.tracking.editProduct = true;
        },
        loadOrderCK: function(ShiftId) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.spinner = true;
            console.log(ShiftId);
            this.ShiftDetailId = ShiftId;
            axios
                .get('shift-header/CKDropped/' + this.ShiftId)
                .then(async response => {
                    this.unique = Object.values(response.data['unique']);
                    this.unqOrd = Object.values(response.data['unqOrd']);
                    console.log(this.unique);

                    var altertb = 0;
                    var shTemp = null;
                    this.unique.forEach(shift => {
                        this.unqOrd.forEach(load => {
                            if (load.ShiftDetail == shift.ShiftDetail) {
                                if (shTemp == null) {
                                    load.show = true;
                                    shTemp = load.ShiftDetail;
                                } else if (shTemp == shift.ShiftDetail) {
                                    load.show = false;
                                    shTemp = load.ShiftDetail;
                                } else if (shTemp != shift.ShiftDetail) {
                                    load.show = true;
                                    shTemp = load.ShiftDetail;
                                }
                            }
                        });
                    });
                    await this.unqOrd.forEach(load => {
                        if (altertb == 0) {
                            load.color = '#FFFFFF';
                            altertb = 1;
                        } else {
                            load.color = '#ebf3fd';
                            altertb = 0;
                        }
                        if (load.dropped == null) {
                            load.dropped = 0;
                        }
                    });
                    this.spinner = false;
                    console.log(this.unqOrd);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
            console.log(this.widthField);
            if (this.$store.state.viewBotton) this.widthField = 4;
            console.log(this.widthField);
        }
    }
};
</script>
<style scoped>
td {
    padding: 5px !important;
}
.r1 {
    background: #6a84ae;
    color: #f7f8e0;
    font-weight: bold;
    height: 5px !important;
}
.r1t {
    background: #f7f8e0;
    color: #03285f;
    font-weight: bold;
}
.r2c1a {
    background: white;
    color: black;
}
.r2a {
    background: white;
    color: black;
}
.r2c1b {
    background: #d7d7d7;
    color: black;
}
.r2b {
    background: #d7d7d7;
    color: black;
}
.r3c3a {
    background: white;
    color: #04b431;
    font-weight: bolder;
}
.r3a {
    background: white;
    color: black;
}
.r3c3b {
    background: #d7d7d7;
    color: #04b431;
    font-weight: bolder;
}
.r3b {
    background: #d7d7d7;
    color: black;
}
.r3c5a {
    background: #f7f8e0;
    color: black;
}
.r3c5b {
    background: #a9e7f1;
    color: black;
}
.r4a {
    background: white;
    color: black;
}
.r4b {
    background: #d7d7d7;
    color: black;
}
.r4c5a {
    background: white;
    color: brown;
    text-align: left;
}
.r4c5b {
    background: #d7d7d7;
    color: brown;
    text-align: left;
}
.btn {
    padding: 0px !important;
    margin: 0px !important;
    color: blueviolet !important;
}
</style>
